import HmEventRegistry from './../model/HmEventRegistry';
import HmAjax from './../util/HmAjax';
import UrlManager from './../model/UrlManager';

const CouponTracker = function(obj){

	let URL = UrlManager.getUrlForAction("COUPON_TRACKING");
	let trackId = (obj && !isNaN(obj.trackId)) ? obj.trackId : 0;


	let isPostDataValid = function(){
		return (URL && URL.length > 0);
	}();

	let isPutDataValid = function(){
		return (URL && URL.length > 0 && trackId > 0);
	}();
	
	this.post=function(success,failure){
		if(isPostDataValid){
			delete obj["trackId"]; //to be generated by system only

			new HmAjax(URL, obj).post(success,failure);
		}else{
			console.warn("Create data invalid", obj);
		}
	}

	this.put=function(success,failure){
		if(isPutDataValid){
			new HmAjax(URL+"/"+trackId, obj).put(success,failure);
		}else{
			console.warn("Update data invalid", obj);
		}
	}	
}

export default CouponTracker;

HmEventRegistry.registerEvent("COUPON_TRACK_CREATE",function(obj,success,failure){
	new CouponTracker(obj).post(success,failure);
});

HmEventRegistry.registerEvent("COUPON_TRACK_UPDATE",function(obj,success,failure){
	new CouponTracker(obj).put(success,failure);
});


// WEBPACK FOOTER //
// ./src/track/CouponTracker.js